import { useQuery } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const get = async (paging?: TPaging) => {
  const response: TServerResponse = await request({
    url: apiUrls.partners.FETCH_PARTNERS,
    method: "GET",
    params: { ...paging },
  });
  return response;
};

export const usePartnersQuery = (paging: TPaging) => {
  return useQuery({
    queryKey: [apiUrls.partners.FETCH_PARTNERS, paging],
    queryFn: () => get(paging),
  });
};
